import * as React from "react"

import { cn } from "@/lib/utils"

const Progress = React.forwardRef(({ className, value, ...props }, ref) => {
  const pct = Math.min(Math.max(value || 0, 0), 100);
  
  return (
    <div
      ref={ref}
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full bg-muted",
        className
      )}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct}
      {...props}
    >
      {/* Filled portion */}
      <div
        className="absolute top-0 left-0 h-full rounded-full transition-all bg-foreground"
        style={{
          width: `${pct}%`,
        }}
      />
    </div>
  )
})
Progress.displayName = "Progress"

export { Progress }
